namespace $.$$ {
	
	$mol_style_define( $hyoo_dnd_char_main, {
		
		flex: {
			basis: '40rem',
		},
		
		Grade: {
			flex: {
				wrap: 'wrap',
			},
		},
		
	} )
	
}
